// Convierte states crudos en series {name, data:[{x:Date, y}]} para ApexCharts.
// Descarta los puntos sin valor válido (p.ej. telemetrías de RP1 que fallaron
// validate y se persistieron sin la clave 'life') para no romper el eje datetime
// al hacer zoom/reset. Antes este filtrado solo existía en el render inicial;
// replicarlo aquí evita que los caminos de zoom/home diverjan.
export const shapeSeries = (states, sensors, names) =>
  sensors.map((sensorName, indx) => ({
    name: names[indx],
    data: states
      .filter(state => state[sensorName] !== undefined && state[sensorName] !== null)
      .map(state => ({ x: new Date(state.created_at), y: state[sensorName] }))
  }))
